import { Component, inject, OnInit } from '@angular/core';
import { DateService, getYear, Store } from '@softline/core';
import {
  MessageBarService,
  ModalContainerComponent,
  UiCoreModule,
} from '@softline/ui-core';
import { RouterModule } from '@angular/router';

import { AppInfoStore, SOFTLINE_FEATURE_APP_INFO } from '@softline/application';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { SOFTLINE_TOKEN_SHELL_ENVIRONMENT } from '../../shell.tokens';
import { ShellEnvironment } from '../../shell.constants';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'soft-public-shell',
  templateUrl: './public-shell.component.html',
  styleUrls: ['./public-shell.component.css'],
  hostDirectives: [CdkScrollable],
  imports: [CommonModule, UiCoreModule, RouterModule, ModalContainerComponent],
  providers: [
    { provide: SOFTLINE_TOKEN_SHELL_ENVIRONMENT, useValue: ShellEnvironment.PUBLIC },
  ],
})
export class PublicShellComponent implements OnInit {
  year?: string;
  messageBarService = inject(MessageBarService);

  version = this.store.signal(SOFTLINE_FEATURE_APP_INFO, AppInfoStore.getters.version, {
    initialValue: '0',
  });

  constructor(
    private store: Store,
    private dateService: DateService
  ) {}

  ngOnInit(): void {
    this.year = '' + getYear(this.dateService.now());
  }
}
